<div class="banner-container d-lg-flex d-none w-100 position-relative" role="banner" [ngClass]="{ 'kid-banner': isKid }">
  <img
    class="position-absolute z-0 banner-image-background"
    [src]="(isKid ? 'banner-images/kid-banner-background.png' : 'banner-images/banner-background.jpg') | contentAssetImage"
    alt="Banner Background"
  />
  <div
    class="container d-flex text-white d-flex justify-content-between h-100 align-items-center overflow-hidden position-relative z-1"
  >
    @if(pageTitle){
    <h2 class="m-0">
      {{ pageTitle }}
    </h2>
    }@else {
    <ng-container *ngTemplateOutlet="template"></ng-container>
    }
    <img class="club-logo" [src]="(isKid ? 'logo/logo-kid.svg' : 'logo/logo.svg') | contentAssetImage" alt="club-logo" />
  </div>
</div>
